export const fetchShareLink = async (
  clientId,
  messageId,
  accessAuthToken,
  audioUrl?: string,
  platformId?: string,
  leagueId?: string,
  authId?: string,
) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL}/functions/endpoints/get_share_link_by_request?client_id=${clientId}&message_id=${messageId}`;

    const requestBody = {
      clientId: clientId,
      messageId: messageId,
      ...(audioUrl && { audioUrl: audioUrl }),
      ...(platformId && { platformId }),
      ...(leagueId && { leagueId }),
      ...(authId && { authId }),
    };

    console.log("requestBody fetchShareLink", requestBody);

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessAuthToken}`,
      },
      body: JSON.stringify(requestBody),
      credentials: "include",
    });

    if (!response.ok) {
      console.error("Error fetching the share link");
      return "Error fetching URL";
    }
    const data = await response.json();
    return data.url;
  } catch (error) {
    console.error("Error fetching the share link:", error);
    return "Error fetching URL";
  }
};
